import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import formatarData from '~js/formatar-data';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaSalvar(solicitacao) {

  if ((solicitacao.tipoSolicitacao == 1) || (solicitacao.tipoSolicitacao == 2)) {
    for (var i = 0; i < solicitacao.faixaValores.length; i++) {
      if (typeof solicitacao.faixaValores[i].anexoObrigatorio === "string") {
        if (solicitacao.faixaValores[i].anexoObrigatorio === 'true' || solicitacao.faixaValores[i].anexoObrigatorio === '1')
          solicitacao.faixaValores[i].anexoObrigatorio = true
        else
          solicitacao.faixaValores[i].anexoObrigatorio = false;

        if (solicitacao.faixaValores[i].utilizarArquivo === 'true' || solicitacao.faixaValores[i].utilizarArquivo === '1')
          solicitacao.faixaValores[i].utilizarArquivo = true
        else
          solicitacao.faixaValores[i].utilizarArquivo = false;
      }
      else {
        if (solicitacao.faixaValores[i].anexoObrigatorio === 1)
          solicitacao.faixaValores[i].anexoObrigatorio = true

        if (solicitacao.faixaValores[i].anexoObrigatorio === 0)
          solicitacao.faixaValores[i].anexoObrigatorio = false

        if (solicitacao.faixaValores[i].utilizarArquivo === 1)
          solicitacao.faixaValores[i].utilizarArquivo = true

        if (solicitacao.faixaValores[i].utilizarArquivo === 0)
          solicitacao.faixaValores[i].utilizarArquivo = false
      }
    }
  }

  if (solicitacao.cadastroCompleto == 1)
    solicitacao.cadastroCompleto = true;

  if (solicitacao.cadastroCompleto == 0)
    solicitacao.cadastroCompleto = false;

  if (solicitacao.permitirEstrangeiro == 1)
    solicitacao.permitirEstrangeiro = true;

  if (solicitacao.permitirEstrangeiro == 0)
    solicitacao.permitirEstrangeiro = false;

  return solicitacao;
}

function normalizarParaVisualizar(solicitacao) {

  for (var i = 0; i < solicitacao.projetos.length; i++) {
    solicitacao.projetos[i].percentual = converterMoeda.paraReal(solicitacao.projetos[i].percentual);
  }

  if ((solicitacao.tipoSolicitacao == 1) || (solicitacao.tipoSolicitacao == 2)) {
    solicitacao.solicitacaoCursoEventos[0].dataInicio = formatarData.dataParaStr(solicitacao.solicitacaoCursoEventos[0].dataInicio);
    solicitacao.solicitacaoCursoEventos[0].dataFim = formatarData.dataParaStr(solicitacao.solicitacaoCursoEventos[0].dataFim);
    solicitacao.solicitacaoCursoEventos[0].dataInicioInscricao = formatarData.dataParaStr(solicitacao.solicitacaoCursoEventos[0].dataInicioInscricao);
    solicitacao.solicitacaoCursoEventos[0].dataLimiteInscricao = formatarData.dataParaStr(solicitacao.solicitacaoCursoEventos[0].dataLimiteInscricao);
    solicitacao.solicitacaoCursoEventos[0].dataVencimentoParcela = formatarData.dataParaStr(solicitacao.solicitacaoCursoEventos[0].dataVencimentoParcela);

    for (var i = 0; i < solicitacao.solicitacaoCursoEventos[0].faixaValores.length; i++) {
      if (!((solicitacao.solicitacaoCursoEventos[0].faixaValores[i].anexoObrigatorio === undefined) || (solicitacao.solicitacaoCursoEventos[0].faixaValores[i].anexoObrigatorio === null))) {
        solicitacao.solicitacaoCursoEventos[0].faixaValores[i].anexoObrigatorio = solicitacao.solicitacaoCursoEventos[0].faixaValores[i].anexoObrigatorio ? "1" : "0";
      }
      if (!((solicitacao.solicitacaoCursoEventos[0].faixaValores[i].utilizarArquivo === undefined) || (solicitacao.solicitacaoCursoEventos[0].faixaValores[i].utilizarArquivo === null))) {
        solicitacao.solicitacaoCursoEventos[0].faixaValores[i].utilizarArquivo = solicitacao.solicitacaoCursoEventos[0].faixaValores[i].utilizarArquivo ? "1" : "0";
      }
      solicitacao.solicitacaoCursoEventos[0].faixaValores[i].valor = converterMoeda.paraReal(solicitacao.solicitacaoCursoEventos[0].faixaValores[i].valor);
    }

    for (var i = 0; i < solicitacao.faixaValores.length; i++) {
      if (!((solicitacao.faixaValores[i].anexoObrigatorio === undefined) || (solicitacao.faixaValores[i].anexoObrigatorio === null))) {
        solicitacao.faixaValores[i].anexoObrigatorio = solicitacao.faixaValores[i].anexoObrigatorio ? "1" : "0";
      }
      if (!((solicitacao.faixaValores[i].utilizarArquivo === undefined) || (solicitacao.faixaValores[i].utilizarArquivo === null))) {
        solicitacao.faixaValores[i].utilizarArquivo = solicitacao.faixaValores[i].utilizarArquivo ? "1" : "0";
      }
      solicitacao.faixaValores[i].valor = converterMoeda.paraReal(solicitacao.faixaValores[i].valor);
    }
  }

  if (solicitacao.tipoSolicitacao == 4) {
    solicitacao.solicitacaoDoacao[0].valorMinimo = converterMoeda.paraReal(solicitacao.solicitacaoDoacao[0].valorMinimo);
    solicitacao.solicitacaoDoacao[0].valorMaximo = converterMoeda.paraReal(solicitacao.solicitacaoDoacao[0].valorMaximo);
    solicitacao.solicitacaoDoacao[0].valorPadrao1 = converterMoeda.paraReal(solicitacao.solicitacaoDoacao[0].valorPadrao1);
    solicitacao.solicitacaoDoacao[0].valorPadrao2 = converterMoeda.paraReal(solicitacao.solicitacaoDoacao[0].valorPadrao2);
    solicitacao.solicitacaoDoacao[0].valorPadrao3 = converterMoeda.paraReal(solicitacao.solicitacaoDoacao[0].valorPadrao3);
    solicitacao.solicitacaoDoacao[0].valorPadrao4 = converterMoeda.paraReal(solicitacao.solicitacaoDoacao[0].valorPadrao4);
  }

  switch (solicitacao.tipoSolicitacao) {
    case 1: 
      solicitacao.tipoSolicitacao = "1"
      break
    case 2:
      solicitacao.tipoSolicitacao = "2"
      break
    case 3:
      solicitacao.tipoSolicitacao = "3"
      break
    case 4:
      solicitacao.tipoSolicitacao = "4"
      break
    default:
      solicitacao.tipoSolicitacao = "0"
  }

  if (solicitacao.permitirEstrangeiro != null) {
    solicitacao.permitirEstrangeiro = solicitacao.permitirEstrangeiro ? 1 : 0;
  }

  if (solicitacao.cadastroCompleto != null) {
    solicitacao.cadastroCompleto = solicitacao.cadastroCompleto ? 1 : 0;
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/solicitacaocursoeventoservico', { params: parametros });
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaocursoeventoservico/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaocursoeventoservico/${id}/cancelar`)
      .then(response => response.data);
  },
  adicionar: (solicitacao, arquivos) => {
    solicitacao = normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaocursoeventoservico', solicitacao).then(res => res.data.id);
  },
  alterar: (solicitacao, arquivos, id) => {
    solicitacao = normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.put(`/api/solicitacaocursoeventoservico/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaocursoeventoservico/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaocursoeventoservico/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaocursoeventoservico/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  traduzir: (objetoTraducao, tipoSol) => {
    objetoTraducao = converterObjetoFormData(objetoTraducao);

    if (tipoSol == 4)
      return Vue.http.post(`/api/Translate/TraduzirDoacaoManagerForm`, objetoTraducao).then(res => res.data);
    else
      return Vue.http.post(`/api/Translate/TraduzirTurmaManagerForm`, objetoTraducao).then(res => res.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-curso-evento-servico/servico.js